<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('profileparameterset_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-file-cog-outline</v-icon>{{ item['uuid'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-profileparameterset-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('profile.profileparameter.uuid') }}</strong></td>
              <td>
                                    {{ item['uuid'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('profile.profileparameter.setup') }}</strong></td>
              <td>
                                    {{ item['setup'].uuid }}
              </td>

              <td><strong>{{ $t('profile.profileparameter.strategy') }}</strong></td>
              <td>
                                    {{ item['strategy'].uuid }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.profileparameter.date') }}</strong></td>
              <td>
                {{ formatDate(item['date'], 'long') }}              </td>

              <td><strong>{{ $t('profile.profileparameter.version') }}</strong></td>
              <td>
                                    {{ item['version'] }}
              </td>
            </tr>



          </tbody>
        </template>
      </v-simple-table>
      <template>
        <div class="profileparametersetvalue-list">
          <Toolbar  />

          <v-container grid-list-xl fluid>
            <v-layout row wrap>
              <v-flex sm12>
                <h1>{{$t('profile.profileparameter.values')}}</h1>
              </v-flex>
              <v-flex lg12>
                <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
                  <ProfileParameterSetValueFilterForm
                    ref="filterForm"
                    :values="filters"
                    slot="filter"
                  />
                </DataFilter>

                <br />

                <v-data-table
                  v-model="selected"
                  :headers="headers"
                  :items="items"
        :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
                  :loading="isLoading"
                  :loading-text="$t('global.loading')"
                  :options.sync="options"
                  :server-items-length="totalItems"
                  class="elevation-1"
                  item-key="@id"
                  @update:options="onUpdateOptions"
@click:row="showHandlerSubEvent"
                >

                  <ActionCell
                  slot="item.action"
                  slot-scope="props"
                  :handle-show="() => showHandlerSub(item,'ProfileParameterSetValue',props.item)"
                  ></ActionCell>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </template>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import ProfileParameterSetValueFilterForm from '../../components/profileparametersetvalue/Filter';
import DataFilter from '../../components/DataFilter';

const servicePrefix = 'ProfileParameterSet';

export default {
  name: 'ProfileParameterSetShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar,
      ActionCell,
      ProfileParameterSetValueFilterForm,
      DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('profile.profileparameter.profileparameter'), value: 'profileParameter.name' },
        { text: this.$t('profile.profileparameter.value'), value: 'value' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      filters: {
        'profileParameterSet' : this.$route.params.id,
      },
      selected: []
    };
  },
  mixins: [ListMixin,ShowMixin,AccessMixin],
  computed: {
    ...mapFields('profileparameterset', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('profileparameterset', ['find']),
    ...mapGetters('profileparametersetvalue', {
      items: 'list'
    }),
    ...mapFields('profileparametersetvalue', {
      isLoading: 'isLoading'
    }),
    ...mapFields('profileparametersetvalue', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('profileparameterset', {
      deleteItem: 'del',
      reset: 'reset',
      update: 'update',
      retrieve: 'load'
    }),
    ...mapActions('profileparametersetvalue', {
        getPage: 'fetchAll',
    }),
    showHandlerSubEvent(value) {
      this.showHandlerSub(this.item,'ProfileParameterSetValue',value);
    }

  }
};
</script>
